<template lang="html">
	<wizard-screen :completed="3" :total="5">
		<div>
			<div class="omapi-onboarding__features-section">
				<h4>Included Features</h4>
				<p>Every OptinMonster subscription includes the following features at no additional cost:</p>
				<div class="omapi-feature-group">
					<wizard-feature v-for="feature in includedFeatures" :key="feature.slug" :feature="feature" />
				</div>
			</div>
			<div class="omapi-onboarding__features-section">
				<h4>Recommended Features</h4>
				<p>Based on your goals, we also recommend the following features:</p>
				<div class="omapi-feature-group">
					<wizard-feature v-for="feature in recommendedFeatures" :key="feature.slug" :feature="feature" />
				</div>
			</div>
			<div class="omapi-onboarding__features-section">
				<h4>Free Add-Ons</h4>
				<p>
					We recommend enhancing your site with these free WordPress plugins.<br />No commitment required -
					you can remove them at any time.
				</p>
				<div class="omapi-feature-group">
					<div>
						<wizard-feature v-for="feature in addOnFeatures" :key="feature.slug" :feature="feature" />
					</div>
				</div>
			</div>
		</div>
		<template #after-card>
			<div class="omapi-text-center">
				<small v-if="pluginsList" class="omapi-will-be-installed">
					The following plugins will be installed for free:
					{{ pluginsList }}
				</small>
			</div>
			<wizard-exit />
		</template>
	</wizard-screen>
</template>

<script lang="js">
import { featureMap } from '@/wizard/data'
import { mapGetters } from 'vuex'

export default {
	data () {
		return {
			addOnSlugs: featureMap.filter(f => f.plugin).map(f => f.slug),
			featureMap,
			includedFeatureSlugs: ['campaigns', 'page-level-targeting'],
			recommendedFeatureSlugs: ['split-test', 'exit-intent', 'yesno', 'content-locker', 'onsite-targeting'],
		}
	},
	computed : {
		...mapGetters('wizard', [ 'inExtraFeatures' ]),
		...mapGetters([ 'onboardingUsage' ]),
		/**
		 * List of plugins that will be installed.
		 *
		 * @returns {string} The compiled list of plugins.
		 */
		pluginsList () {
			const list = this.featureMap.filter(f => {
				return f.plugin && this.inExtraFeatures(f.slug)
			}).map(f => {
				return f.plugin.title
			})

			return list.length ? list.join(', ') : ''
		},
		/**
		 * List of features that are included with every subscription.
		 *
		 * @returns {Array} The list of features.
		 */
		includedFeatures() {
			return this.featureMap.filter(f => {
				return this.includedFeatureSlugs.includes(f.slug)
			})
		},
		/**
		 * List of features that are recommended.
		 *
		 * @returns {Array} The list of features.
		 */
		recommendedFeatures() {
			return this.featureMap.filter(f => {
				return this.recommendedFeatureSlugs.includes(f.slug)
			})
		},
		/**
		 * List of features that are free add-ons/plugins.
		 *
		 * @returns {Array} The list of features.
		 */
		addOnFeatures() {
			return this.featureMap.filter(f => {
				return this.addOnSlugs.includes(f.slug)
			})
		},
	},
};
</script>
